import React from "react";
import "./Footer.css"

function Footer() {
    return <footer className="footer">
        <div className="footer-organized">Organized By</div>
        <div className="footer-images">
            <img src={`${process.env.PUBLIC_URL}/org-nycdot.png`} alt="NYC DOT" className="footer-logo footer-logo-card" />
            <img src={`${process.env.PUBLIC_URL}/org-fhwa.png`} alt="Federal Highway Administration" className="footer-logo" />
            <img src={`${process.env.PUBLIC_URL}/org-c2smart.png`} alt="C2SMART Center" className="footer-logo" />
            <img src={`${process.env.PUBLIC_URL}/org-utrc.png`} alt="University Transportation Research Center" className="footer-logo" />
        </div>
        <div className="footer-hosted">Hosted By</div>
        <div className="footer-hosted-logo-wrap">
            <img src={`${process.env.PUBLIC_URL}/nyu-tandon-white.png`} alt="NYU Tandon School of Engineering" className="footer-hosted-logo" />
        </div>
        <p>© {new Date().getFullYear()} C2SMART</p>
    </footer>
}

export default Footer;
